import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHideIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_7640",
	"data-name": "Group 7640",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 23.999,
	height: 20.5,
	viewBox: "0 0 23.999 20.5",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_13401",
			"data-name": "Rectangle 13401",
			width: 23.999,
			height: 20.5,
			fill: "none",
			stroke: "#618cf5",
			strokeWidth: 1.5
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_7639",
		"data-name": "Group 7639",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12985",
				"data-name": "Path 12985",
				d: "M19.518,6.538A22.111,22.111,0,0,1,23.5,10.25s-5.148,6.5-11.5,6.5a10.3,10.3,0,0,1-3-.464",
				fill: "none",
				stroke: "#618cf5",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12986",
				"data-name": "Path 12986",
				d: "M4.468,13.951A22.106,22.106,0,0,1,.5,10.25S5.649,3.75,12,3.75a10.1,10.1,0,0,1,2.5.325",
				fill: "none",
				stroke: "#618cf5",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12987",
				"data-name": "Path 12987",
				d: "M8,10.25a4,4,0,0,1,4-4",
				fill: "none",
				stroke: "#618cf5",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12988",
				"data-name": "Path 12988",
				d: "M16,10.25a4,4,0,0,1-4,4",
				fill: "none",
				stroke: "#618cf5",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_559",
				"data-name": "Line 559",
				x1: 19.5,
				y2: 19.5,
				transform: "translate(2.25 0.5)",
				fill: "none",
				stroke: "#618cf5",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	})]
});
export default SvgHideIcon;
